import { reducer as accounts, actions as accountsActions } from './Stores/accounts';
import { reducer as admin, actions as adminActions } from './Stores/admin';
import { reducer as apps, actions as appsActions } from './Stores/apps';
import { reducer as auth, actions as authActions } from './Stores/auth';
import { reducer as clientPlugins, actions as clientPluginsActions } from './Stores/clientPlugins';
import { reducer as communication, actions as communicationActions } from './Stores/communication';
import { reducer as connectivity, actions as connectivityActions } from './Stores/connectivity';
import { reducer as conversions, actions as conversionsActions } from './Stores/conversions';
import { reducer as daylight, actions as daylightActions } from './Stores/daylight';
import { reducer as groups, actions as groupsActions } from './Stores/groups';
import { reducer as instances, actions as instancesActions } from './Stores/instances';
import { reducer as meta, actions as metaActions } from './Stores/meta';
import {
  reducer as missionControl,
  actions as missionControlActions,
} from './Stores/missionControl';
import { reducer as muteReasons, actions as muteReasonsActions } from './Stores/muteReasons';
import { reducer as notes, actions as notesActions } from './Stores/notes';
import { reducer as offerings, actions as offeringActions } from './Stores/offerings';
import { reducer as partner, actions as partnerActions } from './Stores/partner';
import { reducer as pims, actions as pimsActions } from './Stores/pims';
import {
  reducer as practiceAlerts,
  actions as practiceAlertsActions,
} from './Stores/practiceAlerts';
import { reducer as practice, actions as practiceActions } from './Stores/practice';
import {
  reducer as practiceWorkflow,
  actions as practiceWorkflowActions,
} from './Stores/practiceWorkflow';
import { reducer as relations, actions as relationsActions } from './Stores/relations';
import { reducer as roles, actions as rolesActions } from './Stores/roles';
import { reducer as toggle, actions as toggleActions } from './Stores/toggle';
import { reducer as users, actions as usersActions } from './Stores/users';
import { reducer as form } from 'redux-form';

import { Services } from '../types/services';

export const stores = (services: Services) => {
  const stores = {
    accounts: {
      reducer: accounts,
      actions: accountsActions,
    },
    admin: {
      reducer: admin,
      actions: adminActions,
    },
    apps: {
      reducer: apps,
      actions: appsActions,
    },
    auth: {
      reducer: auth,
      actions: authActions,
    },
    clientPlugins: {
      reducer: clientPlugins,
      actions: clientPluginsActions,
    },
    communication: {
      reducer: communication,
      actions: communicationActions,
    },
    connectivity: {
      reducer: connectivity,
      actions: connectivityActions,
    },
    conversions: {
      reducer: conversions,
      actions: conversionsActions,
    },
    daylight: {
      reducer: daylight,
      actions: daylightActions,
    },
    form: {
      reducer: form,
      actions: () => ({}),
    },
    groups: {
      reducer: groups,
      actions: groupsActions,
    },
    instances: {
      reducer: instances,
      actions: instancesActions,
    },
    meta: {
      reducer: meta,
      actions: metaActions,
    },
    missionControl: {
      reducer: missionControl,
      actions: missionControlActions,
    },
    muteReasons: {
      reducer: muteReasons,
      actions: muteReasonsActions,
    },
    notes: {
      reducer: notes,
      actions: notesActions,
    },
    offerings: {
      reducer: offerings,
      actions: offeringActions,
    },
    partner: {
      reducer: partner,
      actions: partnerActions,
    },
    pims: {
      reducer: pims,
      actions: pimsActions,
    },
    practice: {
      reducer: practice,
      actions: practiceActions,
    },
    practiceAlerts: {
      reducer: practiceAlerts,
      actions: practiceAlertsActions,
    },
    practiceWorkflow: {
      reducer: practiceWorkflow,
      actions: practiceWorkflowActions,
    },
    relations: {
      reducer: relations,
      actions: relationsActions,
    },
    roles: {
      reducer: roles,
      actions: rolesActions,
    },
    toggle: {
      reducer: toggle,
      actions: toggleActions,
    },
    users: {
      reducer: users,
      actions: usersActions,
    },
  };

  const merged = Object.entries(stores).reduce(
    (acc, [key, value]) => {
      return {
        ...acc,
        actions: {
          ...acc.actions,
          [key]: value.actions(services),
        },
        reducers: {
          ...acc.reducers,
          [key]: value.reducer,
        },
      };
    },
    { reducers: {}, actions: {} },
  );

  return merged;
};
